import React from 'react';

import { Text } from '@common/components';
import { WorksTimekeepingWorkerTimesheetStatus } from '@common/graphql/schema';
import { ColorsType } from '@common/tokens';

const WORKER_TIMESHEET_COLOR_STYLE_MAP: Partial<
  Record<WorksTimekeepingWorkerTimesheetStatus, ColorsType>
> = {
  submitted: 'skyRegular',
  approved: 'grass',
  overdue: 'coral',
  rejected: 'coral',
};

export const WORKER_TIMESHEET_LABEL_OVERWRITE = {
  not_submitted: 'Not Submitted',
  submitted: 'Submitted',
  approved: 'Approved',
  overdue: 'Overdue',
  rejected: 'Rejected',
  processing: 'Processing',
  invoiced: 'Invoiced',
  expired: 'Expired',
} satisfies Record<WorksTimekeepingWorkerTimesheetStatus, string>;

export const WorkerTimesheetStatus = ({
  status,
}: {
  status: WorksTimekeepingWorkerTimesheetStatus;
}) => (
  <Text weight="bolder" color={WORKER_TIMESHEET_COLOR_STYLE_MAP[status]}>
    {WORKER_TIMESHEET_LABEL_OVERWRITE[status] || status}
  </Text>
);
